import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { hasRole, isAdmin, isOwner, ROLE_GROUPS } from '@/utils/constent';
import { useIsAuthenticated } from '@/hooks/redux';
import { useGetUserQuery } from '@/store/api/authApi';

export const useRoleCheck = () => {
  const isAuthenticated = useIsAuthenticated();
  // Subscribes to the same cached query DashboardLayout kicks off, so this
  // just reads its loading state instead of firing a second request.
  const { isLoading, isUninitialized } = useGetUserQuery(undefined, {
    skip: !isAuthenticated,
  });
  const user = useSelector((state: RootState) => state.user);
  const isUserFetched = !isAuthenticated || (!isLoading && !isUninitialized);
  const role = user.data?.role?.name ?? '';

  return {
    role,
    isUserFetched,
    canAccessDWRequest: isUserFetched && hasRole(role, ROLE_GROUPS.CAN_ACCESS_DW_REQUEST),
    canManageUsers: isUserFetched && hasRole(role, ROLE_GROUPS.CAN_MANAGE_USERS),
    canViewReports: isUserFetched && hasRole(role, ROLE_GROUPS.CAN_VIEW_REPORTS),
    isOwner: isUserFetched && isOwner(role),
    isAdmin: isUserFetched && isAdmin(role),
    checkRole: (allowedRoles: readonly string[]) => isUserFetched && hasRole(role, allowedRoles),
  };
};
